import { Resource } from 'model/Resource';
import { WebLinkDistributionModel } from 'api/dto/WebLinkDistribution.dto';

export const STORE_NAME = 'webLink';

export namespace WebLinkDistributionState {
  export type WebLinkDistributionResource = Resource<WebLinkDistributionModel>;
  export type Domain = {
    distributionResource?: WebLinkDistributionResource;
  };

  export const INITIAL_WEBLINK_DISTRIBUTION_RESOURCE: WebLinkDistributionResource =
    Resource.createPendingResource<WebLinkDistributionModel>();

  export const INITIAL_DOMAIN: Domain = {
    distributionResource: INITIAL_WEBLINK_DISTRIBUTION_RESOURCE,
  };
}
